// extracted by mini-css-extract-plugin
module.exports = {"Choose":"Choose_Choose__G04DP"};